<script setup lang="ts">
import { onMounted, ref } from 'vue'
import ActivityCard from '../components/ActivityCard.vue'
import StatePanel from '../components/StatePanel.vue'
import { api, listOf } from '../services/api'
import { authState } from '../services/auth'

const items = ref<any[]>([])
const loading = ref(true)
const error = ref('')
async function load() {
  loading.value = true; error.value = ''
  try {
    const id = authState.value?.user.id || ''
    const [joined, created] = await Promise.all([
      api<any>(`/activity/search?enrolledUserId=${encodeURIComponent(id)}&page=1&pageSize=50`),
      api<any>(`/activity/search?creatorId=${encodeURIComponent(id)}&page=1&pageSize=50`),
    ])
    const map = new Map<string, any>()
    ;[...listOf(joined), ...listOf(created)].forEach((item) => map.set(String(item.id), item))
    items.value = Array.from(map.values())
  } catch (reason: any) { error.value = reason?.message || '加载失败' }
  finally { loading.value = false }
}
onMounted(load)
</script>

<template><div class="shell subpage"><div class="subpage-head"><div><span class="section-kicker">MY ACTIVITIES</span><h1>我的活动</h1><p>这里只展示公开活动，不包含私人记录、比分或练习。</p></div><RouterLink class="button button-primary" to="/activities/new">发布活动</RouterLink></div><StatePanel v-if="loading" mode="loading" /><StatePanel v-else-if="error" mode="error" :description="error" @retry="load" /><div v-else-if="items.length" class="activity-list"><ActivityCard v-for="item in items" :key="item.id" :activity="item" /></div><StatePanel v-else mode="empty" title="还没有活动" description="报名一个球局，或自己发起一场。" /></div></template>
